import { Alert, Snackbar } from "@mui/material";

export default function Feedback(props) {
  // FUNCTIONS
  const closeFeedback = () => {
    if (props.setOpen) {
      props.setOpen(false);
    }
  };

  // RENDER
  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      open={props.open}
      autoHideDuration={6000}
      onClose={closeFeedback}
    >
      <Alert
        onClose={closeFeedback}
        severity={props.severity || "success"}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {props.message}
      </Alert>
    </Snackbar>
  );
}
